// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3KPnc","calendarButtons":"ClockData_calendarButtons__2JYVU"};